import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';

import {
    getSimpleDateFromISOString,
    getSimpleHoursMinutesFromISOString,
} from '../../../utils/dateFunctions';
import {getUniqueDataDays} from '../../../utils/arrayFunction';

import CustomCalendar from './CustomCalendar';
import TypeRange from '../Type-Range/Type-Range';
import TypeBarchart from '../Type-Barchart/TypeBarchart';
import EditType from '../Edit-Type/Edit-Type';
import TypeNavbar from '../Type-Navbar/Type-Navbar';
import ReadingAdd from '../Reading-Add/Reading-Add';


export default function Type({authFetch}) {
    const {typeId} = useParams();
    const [origType, setOrigType] = useState('');
    const [origTypeReadings, setOrigTypeReadings] = useState([]);

    const [user, setUser] = useState([]);

    const [formVisible, setFormVisible] = useState(false);
    const [daysVisible, setDaysVisible] = useState(true);
    const [readingsVisible, setReadingsVisible] = useState(false);
    const [barVisible, setBarVisible] = useState(false);
    const [areaVisible, setAreaVisible] = useState(false);
    const [editTypeVisible, setEditTypeVisible] = useState(false);

    const toggleVisibility = () => {
        setFormVisible(true);
        setDaysVisible(false);
        setReadingsVisible(false);
        setBarVisible(false);
        setAreaVisible(false);
        setEditTypeVisible(false);
    };

    const toggleDays = () => {
        setFormVisible(false);
        setDaysVisible(true);
        setReadingsVisible(false);
        setBarVisible(false);
        setAreaVisible(false);
        setEditTypeVisible(false);
    };

    const toggleReadings = () => {
        setFormVisible(false);
        setDaysVisible(false);
        setReadingsVisible(true);
        setBarVisible(false);
        setAreaVisible(false);
        setEditTypeVisible(false);
    };

    const toggleBarChart = () => {
        setFormVisible(false);
        setDaysVisible(false);
        setReadingsVisible(false);
        setBarVisible(true);
        setAreaVisible(false);
        setEditTypeVisible(false);
    };

    const toggleAreaGraph = () => {
        setFormVisible(false);
        setDaysVisible(false);
        setReadingsVisible(false);
        setBarVisible(false);
        setAreaVisible(true);
        setEditTypeVisible(false);
    };

    const toggleEditType = () => {
        setFormVisible(false);
        setDaysVisible(false);
        setReadingsVisible(false);
        setBarVisible(false);
        setAreaVisible(false);
        setEditTypeVisible(true);
    };


    useEffect(() => {
        const fetchUserProfile = async () => {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/user/profile`);
            const data = await response.json();
            setUser(data);
        };

        fetchUserProfile();
    }, [authFetch]);


    useEffect(() => {
        const fetchUserType = async () => {

            const response = await authFetch(`${process.env.REACT_APP_API_URL}/type/${typeId}`);
            const data = await response.json();
            setOrigType(data);
        };

        const fetchUserTypeReadings = async () => {

            const response = await authFetch(`${process.env.REACT_APP_API_URL}/reading/type/${typeId}`);
            const data = await response.json();
            setOrigTypeReadings(data);
        };

        fetchUserType();
        fetchUserTypeReadings();
    }, [authFetch, typeId]);

    const userId = user._id;

    const uniqueDayArray = getUniqueDataDays(origTypeReadings);

    return (
        <>
            <TypeNavbar origType={origType}
                        toggleDays={toggleDays}
                        daysVisible={daysVisible}
                        toggleBarChart={toggleBarChart}
                        barVisible={barVisible}
                        toggleAreaGraph={toggleAreaGraph}
                        areaVisible={areaVisible}
                        toggleEditType={toggleEditType}
                        editTypeVisible={editTypeVisible}
                        toggleReadings={toggleReadings}
                        readingsVisible={readingsVisible}
                        toggleVisibility={toggleVisibility}
                        formVisible={formVisible}/>

            {editTypeVisible === true ? (<>
                <EditType authFetch={authFetch} origType={origType} typeId={typeId}/>
            </>) : <></>}

            {formVisible === true ? (
                <>
                    <ReadingAdd authFetch={authFetch} origType={origType} userId={userId}/>
                </>
            ) : <></>}

            {barVisible === true ? (<>
                <TypeBarchart amountData={origTypeReadings} origType={origType}/>
            </>) : <></>}

            {areaVisible === true ? (<>
                <TypeRange authFetch={authFetch} origType={origType} typeId={typeId}/>
            </>) : <></>}

            {daysVisible === true ? (
                <>
                    <CustomCalendar typeDays={uniqueDayArray} origType={origType} typeId={typeId}
                                    amountData={origTypeReadings}/>
                </>
            ) : <></>}

            {readingsVisible === true ? (
                <>
                    <h2>{origType.name} Readings</h2>
                    <ul>
                        {origTypeReadings.length > 0 && origTypeReadings.map((reading) => {
                            return (
                                <li key={reading._id}>
                                    {getSimpleDateFromISOString(reading.dateTime)} {getSimpleHoursMinutesFromISOString(reading.dateTime)} - {reading.activeAmount}{origType.activeUnits} {reading.note} - <a
                                    href={'/edit-reading/' + reading._id}>edit</a>
                                </li>
                            );
                        })}
                    </ul>
                </>
            ) : <></>}

        </>
    );
}
